<template>
    <v-container style="max-width:100vw;" v-if="this.currentUser.permissions!=undefined">
        <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="filters" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <filterQuotations @filtersQuotation="filtersQuotation"/>
        </v-navigation-drawer>
        <v-data-table 
        :headers="showHeaders" 
        :items="quotations" 
        class="elevation-0 px-6 py-4"
        :multi-sort="true"
        height="600"
        fixed-header
        :footer-props="{'items-per-page-options':[15, 30, 50, 500, totalQuotations>999?999:totalQuotations]}"
        v-if="showTable"
        :options.sync="options"
        v-sortable-table="{onEnd:sortTheHeadersAndUpdateTheKey}"
        :key="anIncreasingNumber" 
        :server-items-length="totalQuotations"
        :loading="loading">
            <!-- Header -->
            <template v-slot:header.campaign_contact>
                <span>Contacto <br>Campaña</span>
            </template>
            <template v-slot:header.campaign_status>
                <span>Estatus de<br> Campaña</span>
            </template>
            <template v-slot:header.service_date>
                <span>Fecha de<br> Servicio</span>
            </template>
            <template v-slot:header.dollar_amount>
                <span>Monto en<br> Dolares</span>
            </template>
            <template v-slot:header.peach_invoice_file>
                <span>Factura<br> Marca</span>
            </template>
            <template v-slot:header.finance_contact>
                <span>Contacto<br> Financiero</span>
            </template>
            <template v-slot:header.deadline_date>
                <span>Fecha<br> Cierre</span>
            </template>
            <template v-slot:header.pay_day>
                <span>Fecha<br> de Pago</span>
            </template>
            <template v-slot:header.invoice_date>
                <span>Fecha<br> Factura</span>
            </template>
            <template v-slot:top>
                <v-toolbar flat class="mb-2">
                    <v-toolbar-title>Ventas</v-toolbar-title>
                    <v-btn icon v-if="!filterStorageLength>0" @click="openFilter()">
                        <v-icon>mdi-filter</v-icon>
                    </v-btn>
                    <v-btn icon v-else @click="openFilter()">
                        <v-badge overlap color="primary">
                            <template v-slot:badge>
                                {{filterStorageLength}}
                            </template>
                            <v-icon>mdi-filter</v-icon>
                        </v-badge>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-select style="max-width:350px!important;" class="mr-4 mt-6" v-model="selectedHeaders" :items="headers" label="Columnas" dense multiple outlined return-object>
                        <template v-slot:prepend-item>
                            <v-list-item ripple @mousedown.prevent @click="toggle">
                            <v-list-item-action>
                                <v-icon :color="selectedHeaders.length > 0 ? 'primary' : ''">
                                {{ icon }}
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                Seleccionar Todo
                                </v-list-item-title>
                            </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <v-chip color="primary" x-small v-if="index < 2">
                                <span style="font-size:11px;">{{ item.text }}</span>
                            </v-chip>
                            <span v-if="index === 2" style="font-size:10px!important;" class="grey--text caption">(+{{ selectedHeaders.length - 2 }} más)</span>
                        </template>
                    </v-select>
                </v-toolbar>
            </template>
            <template v-slot:[`item.influencer`]="{ item }">
                {{item.influencer!=undefined?item.influencer.social_networks.instagram:''}}
            </template>

            <template v-slot:[`item.subtotal`]="{ item }">
                {{(item.subtotal*1).toLocaleString('es-MX', { style: 'currency', minimumFractionDigits: 0, currency: 'MXN',})}}
            </template>
            <template v-slot:[`item.iva`]="{ item }">
                {{(item.iva*1).toLocaleString('es-MX', { style: 'currency', minimumFractionDigits: 0, currency: 'MXN',})}}
            </template>
            <template v-slot:[`item.total`]="{ item }">
                {{(item.total*1).toLocaleString('es-MX', { style: 'currency', minimumFractionDigits: 0, currency: 'MXN',})}}
            </template>

            <!-- Creación -->
            <template v-slot:[`item.created_at`]="{ item }">
                {{item.created_at.slice(0, 10)}}
            </template>
            <template v-slot:[`deadline_date`]="{ item }">
            {{deadline_date!=null?deadline_date:'SIN FECHA CIERRE'}}
            </template>
            <!-- Actualización -->
            <template v-slot:[`item.updated_at`]="{ item }">
                {{item.updated_at.slice(0, 10)}}
            </template>
            <!--template v-slot:[`item.pdfs`]="{ item }">
                <div v-if="item.pdfs!=undefined" >
                    <v-btn v-for="(pdf, index) in item.pdfs" :key="index" v-bind:href="'https://peach.blitzhub.mx/files/' + pdf" target="_blank" icon>
                        <v-icon small>mdi-file-check-outline</v-icon>
                    </v-btn>
                </div>
            </template-->
            <template v-slot:[`item.peach_invoice_file`]="{ item }">
                <v-btn v-if="item.peach_invoice_file!=undefined" v-bind:href="'https://peach.blitzhub.mx/files/' + item.peach_invoice_file" target="_blank" icon>
                    <v-icon small>mdi-file-check-outline</v-icon>
                </v-btn>
            </template>
            <!-- Tabla sin información -->
            <template v-slot:no-data>
                No existen registros de ventas aún
            </template>
            <!-- Empresa -->
        </v-data-table>
    </v-container>
</template>

<script>
    function watchClass(targetNode, classToWatch) {
        let lastClassState = targetNode.classList.contains(classToWatch);
        const observer = new MutationObserver((mutationsList) => {
            for (let i = 0; i < mutationsList.length; i++) {
            const mutation = mutationsList[i];
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const currentClassState = mutation.target.classList.contains(classToWatch);
                if (lastClassState !== currentClassState) {
                lastClassState = currentClassState;
                if (!currentClassState) {
                    mutation.target.classList.add('sortHandle');
                }
                }
            }
            }
        });
        observer.observe(targetNode, { attributes: true });
    }
    import Sortable from 'sortablejs';
    import axios from "axios";
    import Filter from "../sales/filter"
    export default {
        components: {
            'filterQuotations':Filter,
        }, 
        data: () => ({
            anIncreasingNumber: 1,
            statusData:'',
            statusId:'',
            quotation:'',
            sheet2: false,
            sheet: false,
            filters: false,
            emailDialog: false,
            editDialog: false,
            createDialog: false,
            detailDialog:false,
            rejectionDialog:false,
            liquidarDialog:false,
            deleteId:'',
            rejectionData:'',
            rejectionId:'',

            quotations: '',
            headers:[],
            selectedHeaders: [],
            options: {
                page: 1,
                itemsPerPage: 15,
                sortBy: ['id', 'deadline_date'],
                sortDesc: [false, false],
            },
            showTable:true,
            totalQuotations:0,
            loading:false,
            filterStorageLength:0,
            quotationsLength:0,

        }),
        computed: {
            showHeaders () {
                if(this.quotations!=''){
                    return this.headers.filter(s => this.selectedHeaders.includes(s));
                }else{
                    this.quotations = this.quotationsLists
                    return this.headers.filter(s => this.selectedHeaders.includes(s));
                }
            },
            showAgency(){
                if(this.prop_agency_id == null){
                    return { text: 'Agencia', value: 'agency', sortable: false}
                }else{
                    return false
                }
            },
            showBrand(){
                if(this.prop_brand_id == null){
                    return { text: 'Marca', value: 'brand', sortable: false}
                }else{
                    return false
                }
            },
            currentUser(){
                return this.$store.state.currentUser.user;
            },
            headersMap () {
                const agencia = this.showAgency;
                const marca   = this.showBrand;
                return [
                    { text: 'Folio', value: 'id' },    
                    { text: 'Influencer', value: 'influencer', sortable: false },
                    { text: 'Estatus de Campaña', value: 'campaign_status', sortable: false },
                    //agencia,
                    marca,
                    { text: 'Campaña', value: 'campaign' },
                    //{ text: 'Contacto Campaña', value: 'campaign_contact', sortable: false },
                    { text: 'Servicio', value: 'service' },
                    { text: 'Fecha de Servicio', value: 'service_date' },
                    { text: 'Subtotal', value: 'subtotal' },
                    { text: 'IVA', value: 'iva' },
                    { text: 'Total', value: 'total' },
                    { text: 'Monto en Dólares', value: 'dollar_amount', sortable: false },
                    { text: 'Responsable Kams', value: 'salesman', sortable: false },
                    { text: 'Fecha de Creación', value: 'created_at', sortable: false },
                    { text: 'Contacto Financiero', value: 'finance_contact', sortable: false },

                    { text: 'Factura Marca', value: 'invoice' },
                    { text: 'Factura Marca Archivo', value: 'peach_invoice_file', sortable: false },
                    { text: 'Fecha Factura', value: 'invoice_date' },
                    { text: 'Fecha de Cierre', value: 'deadline_date' },
                    
                    { text: 'Fecha de Pago Marca', value: 'pay_day' },
                    //{ text: 'Contrato (Cliente/Peach)', value: 'pdfs', sortable: false },
                ]
            },

            rejectionsLists(){
                return this.$store.state.rejection.rejections;
            },
            likesAllFruit () {
                return this.selectedHeaders.length === this.headersMap.length
            },
            likesSomeFruit () {
                return this.selectedHeaders.length > 0 && !this.likesAllFruit
            },
            icon () {
                if (this.likesAllFruit) return 'mdi-close-box'
                if (this.likesSomeFruit) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
        },
        mounted () {
            this.headers = Object.values(this.headersMap);
            this.selectedHeaders = this.headers;
        },
        directives: {
            'sortable-table': {
                inserted: (el, binding) => {
                    el.querySelectorAll('th').forEach((draggableEl) => {
                        // Need a class watcher because sorting v-data-table rows asc/desc removes the sortHandle class
                        watchClass(draggableEl, 'sortHandle');
                        draggableEl.classList.add('sortHandle');
                    });
                    Sortable.create(el.querySelector('tr'), binding.value ? { ...binding.value, handle: '.sortHandle' } : {});
                },
            },
        },
        watch: {
            options: {
                handler () {
                    if(JSON.stringify(this.currentUser).length>10){
                        this.getDataFromApi()
                    }
                },
                deep: true,
            },
            currentUser: {
                handler () {
                    this.getDataFromApi()
                    this.headers = Object.values(this.headersMap);
                    this.selectedHeaders = this.headers;
                },
                deep: true,
            },
        },
        methods: {
            getDataFromApi () {
                this.loading = true
                this.apiCall().then(data => {
                    this.quotations = data.items
                    this.totalQuotations = data.total
                    this.loading = false
                })
            },
            apiCall () {
                return new Promise((resolve, reject) => {
                    this.filterStorageLength = localStorage.getItem('filtersSalesLength')?.length
                    const { sortBy, sortDesc, page, itemsPerPage } = this.options
                    var items = []
                    var total = 0
                    var link = this.$store.state.currentUser.sale_filter
                    if(localStorage.getItem('filtersSales')!=null){
                        link = link + JSON.parse(localStorage.getItem('filtersSales'))+'&'
                    }else{
                        link = link + 'filter[pending_sales]=1&'
                    }
                    if(this.prop_brand_id!=undefined){
                        link = link + 'filter[brand_id]=' + this.prop_brand_id + '&'
                    }
                    if(this.prop_agency_id!=undefined){
                        link = link + 'filter[agency_id]=' + this.prop_agency_id + '&'
                    }
                    if(this.influencer!=undefined){
                        link = link + 'filter[influencer_id]=' + this.influencer + '&'
                    }
                    if(this.$route.params.sale_id!=undefined){
                        link = link + 'filter[id]=' + this.$route.params.sale_id + '&'
                    }
                    if(sortBy?.length > 0){
                        link = link +  "sort="
                        for(var i=0; i<sortBy?.length; i++){
                            if(sortDesc[i]){
                                link = link + "-" + sortBy[i] + (i<(sortBy?.length - 1)?',':'&')
                            }else{
                                link = link + sortBy[i] + (i<(sortBy?.length - 1)?',':'&')
                            }
                        }
                    }
                    axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/sales?" + link + "page=" + page + "&itemsPerPage=" + itemsPerPage + '&status=vendido').then(response => {
                        this.quotationsLength = response.data.meta.total
                        items = this.mapQuotations(response.data.data)
                        total = response.data.meta.total
                        resolve({
                            items,
                            total,
                        })
                    })
                })
            },
            agency(agency){
                if(agency!=undefined){
                    return agency.name
                }else{
                    return ''
                }
            },
            department(is_boooking){
                if(is_boooking){
                    return 'BOOKING'
                }else{
                    return 'MGMT'
                }
            },
            mapQuotations(quotations){
                return quotations.map(id=>{
                    return{
                        id: id.id,
                        influencer: id.influencer,
                        campaign_status:id.campaign_status,
                        agency: this.agency(id.agency),
                        brand: this.agency(id.brand),
                        campaign:id.campaign,
                        campaign_contact: this.completeName(id.campaign_contact),
                        service: id.service,
                        service_date: id.service_date,
                        subtotal: id.subtotal,
                        iva: id.iva,
                        total: id.total,
                        dollar_amount: id.dollar_amount,
                        salesman: this.completeName(id.agent),
                        created_at:id.created_at,
                        finance_contact: this.completeName(id.finance_contact),
                        invoice: id.invoice,
                        peach_invoice_file:id.peach_invoice_file,
                        invoice_date: id.invoice_date,
                        deadline_date:this.promesadepago(id.deadline_date),
                        pay_day: id.pay_day,
                    }
                })
            },
            completeName(name){
                if(name!=undefined){
                    return name.name + ' ' + (name.last || '')
                }
            },
            promesadepago(date){
                if(date!=null){
                    return this.month(date.slice(5,7)) + ' ' + date.slice(0,4)
                }
            },
            sortTheHeadersAndUpdateTheKey(evt) {
                const headersTmp = this.showHeaders;
                const oldIndex = evt.oldIndex;
                const newIndex = evt.newIndex;
                if (newIndex >= headersTmp.length) {
                    let k = newIndex - headersTmp.length + 1;
                    while (k--) {
                        headersTmp.push(undefined);
                    }
                }
                headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
                this.table = headersTmp;
                this.anIncreasingNumber += 1;
            },
            toggle () {
                this.$nextTick(() => {
                    if (this.likesAllFruit) {
                        this.selectedHeaders = []
                    } else {
                        this.selectedHeaders = this.headersMap.slice()
                    }
                })
            },
            month(date){
                var meses = new Array ("Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre");
                return meses[(date*1)-1]
            },
            openFilter(){
                if(this.filters == false){
                    this.$emit("closeDrawer", false);
                    this.filters = true
                }else{
                    this.$emit("closeDrawer", true);
                    this.filters = false
                }
            },
            permissions(permission){
                if(this.currentUser.id==1){
                    return true
                }else if(this.currentUser.permissions!=undefined){
                    if(this.currentUser.permissions.includes(permission)){
                        return true
                    }else{
                        return false
                    }
                }else{
                    return false
                }
            },
            filtersQuotation: function(params) {
                this.getDataFromApi()
            },
        }
    }
</script>
<style>
    .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
        box-shadow: none!important;
        background: #f7f7f7;
    }
    
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
        padding: 0 8px!important;
    }
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
        font-size:13px!important;
    }
    .v-row-group__header .ma-0.v-btn.v-btn--icon.v-btn--round.theme--light.v-size--small:nth-child(2){
        display:none!important;
    }
    .v-data-table-header th {
        white-space: nowrap;
    }
    .theme--light.v-data-table .v-row-group__header, .theme--light.v-data-table .v-row-group__summary {
        background: #f4f5fa;
    }
    .v-text-field--outlined fieldset {
        border-color: #e0e0e0;
    }
    .v-list-item__action {
        margin: 0px 20px 0px 0px!important;
    }
    .v-menu__content.theme--light.menuable__content__active{
        max-height: 85vh!important;
    }

    .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
        padding: 0 0px!important;
    }
    .btnText2{
        padding: 0px!important;
        height: auto!important;
        background: rgb(219, 219, 219)!important;
        box-shadow: none!important;
        /*text-transform: none;*/
        font-weight: 400;
        font-family: "Roboto", sans-serif;
        letter-spacing: 0;
        color: #1f1f1f!important;
        text-decoration: none!important;
    }


    .is_active{
        border-left: 3px solid #4385f3;
    }
    .is_inactive{
        border-left: 3px solid #33a952;
    }

    .is_activeStyle-1 {
        background-color: #fff2ca;
        border-left: 3px solid #4385f3;
    }
    .is_activeStyle-2 {
        background-color: #d9ebff;
        border-left: 3px solid #4385f3;
    }
    .is_activeStyle-3 {
        background-color: #0080002b;
        border-left: 3px solid #4385f3;
    }
    .is_activeStyle-4 {
        background-color: #ff75002b;
        border-left: 3px solid #4385f3;
    }

    .is_inactiveStyle-1 {
        background-color: #fff2ca;
        border-left: 3px solid #33a952;
    }
    .is_inactiveStyle-2 {
        background-color: #d9ebff;
        border-left: 3px solid #33a952;
    }
    .is_inactiveStyle-3 {
        background-color: #0080002b;
        border-left: 3px solid #33a952;
    }
    .is_inactiveStyle-4 {
        background-color: #ff75002b;
        border-left: 3px solid #33a952;
    }


    table{
        border-collapse: collapse;
    }

    .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
        padding: 0 5px !important;
        font-size:10px!important;
    }
</style>


